// @flow
import React from 'react'
import styled from 'styled-components'
import { mediaMax } from 'components/styles/_media'
import Colors from 'components/styles/colors'
import SearchSort from 'containers/organisms/SearchSort'

const Container = styled.div`
  padding-bottom: 24px;
  margin-bottom: 20px;
  border-bottom: 1px solid ${Colors.grayE};
  ${mediaMax.desktop`
    padding-bottom: 12px;
  `};
`
const Title = styled.h1`
  color: ${Colors.black};
  font-size: 24px;
  font-weight: bold;
  line-height: 1.25;
  ${mediaMax.desktop`
    font-size: 16px;
    font-weight: bold;
  `};
`
const Description = styled.p`
  margin-top: 20px;
  font-size: 14px;
  line-height: 1.5;
  ${mediaMax.desktop`
    margin-top: 12px;
    font-size: 13px;
  `};
`
export const Head = styled.div`
  margin-bottom: 16px;
  ${mediaMax.desktop`
    margin-bottom: 8px;
    position: relative;
  `};
`
export const ResultNumber = styled.span`
  display: inline-block;
  margin-left: 4px;
  font-size: 18px;
  font-weight: bold;
  ${mediaMax.desktop`
    font-size: 14px;
    padding-bottom: 4px;
    margin: 0;
  `};
`
export const ResultNumberCases = styled.span`
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  margin-left: 4px;
  ${mediaMax.desktop`
    font-size: 13px;
  `};
`
export const MainTitle = styled.h1`
  float: left;
  display: block;
  ${mediaMax.desktop`
    font-size: 14px;
    font-weight: bold;
    position: absolute;
    bottom: 0;
  `};
`
export const MainTitleContentPc = styled.span`
  display: inline-block;
  font-size: 14px;
  font-weight: normal;
  ${mediaMax.desktop`
    display: none;
  `};
`
export const MainTitleContentSp = styled.span`
  display: none;
  ${mediaMax.desktop`
    display: block;
    font-size: 13px;
  `};
`
export const HeadRightWrapper = styled.div`
  float: right;
  margin-top: 4px;
`
export const Type = styled.div`
  display: inline-block;
  margin-right: 8px;
  ${mediaMax.desktop`
    margin-right: 4px;
  `};
`
export const ViewType = styled.a`
  position: relative;
  display: inline-block;
  padding-left: 18px;
  font-size: 14px;
  ${mediaMax.desktop`
    padding: 4px 0 4px 20px;
    font-size: 13px;
  `} &:hover {
    text-decoration: underline;
  }

  &::before {
    position: absolute;
    top: 50%;
    left: 0;
    transform: translate(0, -50%);
    color: ${Colors.blue};
    font-size: 14px;
    font-family: 'fonts' !important;
    speak: none;
    font-style: normal;
    font-weight: normal;
    font-variant: normal;
    text-transform: none;
    line-height: 1;
    -webkit-font-smoothing: antialiased;
    content: '\\e93c';
    ${mediaMax.desktop`
      font-size: 14px;
    `};
  }
`

export type PropTypes = {
  title: string,
  description: string,
}

export default props => {
  return (
    <div>
      {props.title ? (
        <Container>
          <Title>{props.title}</Title>
          <Description>{props.description}</Description>
        </Container>
      ) : (
        <MainTitleContentSp>
          {i18n.t('page.search.searchResult')}
        </MainTitleContentSp>
      )}
      <Head className="clearfix">
        <MainTitle>
          <MainTitleContentPc>
            {i18n.t('page.search.searchResult')}
          </MainTitleContentPc>
          <ResultNumber>{props.totalCount}</ResultNumber>
          <ResultNumberCases>
            {i18n.t('page.search.resultCountUnit')}
          </ResultNumberCases>
        </MainTitle>
        <HeadRightWrapper>
          <Type>
            <ViewType
              href={props.mapViewLink}
              onClick={(e: SyntheticEvent) => {
                e.preventDefault()
                props.onClickViewType && props.onClickViewType()
              }}
            >
              {i18n.t('page.search.mapView')}
            </ViewType>
          </Type>
          <SearchSort />
        </HeadRightWrapper>
      </Head>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/organisms/RoomListHeader/index.jsx